import image2 from "../images/gallery/gallery1.jpg";
import image3 from "../images/crest_trans_brown.png";
import image4 from "../images/gallery/gallery2.jpg";
import image5 from "../images/haus.jpg";
import image6 from "../images/gallery/gallery3.jpg";
import image7 from "../images/gallery/gallery4.jpg";
import image8 from "../images/gallery/gallery5.jpg";
import image9 from "../images/gallery/gallery6.jpg";
import image10 from "../images/gallery/gallery7.jpg";
import image11 from "../images/gallery/gallery8.jpg";
import image12 from "../images/gallery/gallery9.jpg";
import image13 from "../images/gallery/gallery10.jpg";
import image15 from "../images/gallery/gallery12.jpg";

export const itemData = [
  {
    img: image4,
    title: "Certificate",
    author: "OHK",
  },
  {
    img: image5,
    title: "Video-animation",
    author: "OHK",
  },
  {
    img: image6,
    title: "Poster",
    author: "OHK",
  },
  {
    img: image7,
    title: "Branding",
    author: "OHK",
  },
  {
    img: image9,
    title: "Moving Text",
    author: "OHK",
  },

  {
    img: image13,
    title: "Branding",
    author: "OHK",
  },
  {
    img: image8,
    title: "3D modelling",
    author: "OHK",
  },
  {
    img: image11,
    title: "Logo",
    author: "OHK",
  },

  {
    img: image12,
    title: "Character Design",
    author: "OHK",
  },
  {
    img: image10,
    title: "Playing Card",
    author: "OHK",
  },

  {
    img: image15,
    title: "Ticket",
    author: "OHK",
  },

  {
    img: image2,
    title: "T-Shirt",
    author: "OHK",
  },
  {
    img: image3,
    title: "Logo",
    author: "OHK",
  },
];
